import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";
import {
  Icon,
  Popover,
  PopoverContent,
  PopoverTrigger,
  RadioGroup,
} from "@b2bportal/core-ui";
import { useI18nContext } from "@hopper-b2b/i18n";
import { useSort, type SortComponentProps } from "@tenant/flights";
import clsx from "clsx";
import styles from "./styles.module.scss";

export const Sort = ({
  children,
  className,
  value,
  handleSortChange,
}: SortComponentProps) => {
  const [, cn] = useModuleBEM(styles, CoreFlightsComponent.Sort);
  const { t } = useI18nContext();

  const {
    context: { sortOptions },
    handlers: { getSortLabelKey },
  } = useSort();

  return (
    <Popover>
      <PopoverTrigger className={clsx(cn("sort-button"), className)}>
        <Icon iconName={IconNameEnum.sort} />
        {t(getSortLabelKey(value))}
      </PopoverTrigger>
      <PopoverContent className={clsx(cn("sort-content"), className)}>
        <RadioGroup
          options={sortOptions}
          selectedOption={value}
          onSelectValue={(value) => handleSortChange(value)}
          className={cn("radio-group")}
        />
        {children}
      </PopoverContent>
    </Popover>
  );
};
